<template>
	<div v-if="allGameList.length > 1" class="game-list-wrapper">
		<a v-if="naviPageIndex > 0" class="icon-previews" @click="movePrev">
			<svgIcon icon-holder-class="icon-nav" icon-id="icon-page-left" />
		</a>

		<div class="game-list-window">
			<ul id="gameListBottom" class="game-list list-unstyled list-inline" :style="{ left: -(naviPageIndex * 128) + 'px' }">
				<li
					v-for="(game, $index) in allGameList"
					:key="'nav.' + $index"
					:class="{ active: listIndex === $index }"
					@click="moveTo(game, $index)"
				>
					<div
						v-if="game.type === 'pc' || game.type === 'console'"
						class="icon"
						:style="{ backgroundImage: `url(${cdnHost}${game.webImages.pcIcon})` }"
					></div>
					<div
						v-if="game.type === 'mobile'"
						class="icon"
						:style="{ backgroundImage: `url(${cdnHost}${game.webImages.mobileIcon})` }"
					></div>
					<span>{{ game.title }}</span>
				</li>
			</ul>
		</div>

		<a v-if="allGameList.length - naviPageIndex > pageSize" class="icon-next" @click="moveNext">
			<svgIcon icon-holder-class="icon-nav" icon-id="icon-page-right" />
		</a>
	</div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';

export default {
	name: 'GameListNavigation',
	components: {
		svgIcon,
	},
	props: {
		allGameList: {
			type: Array,
			default: () => [],
		},
		listIndex: {
			type: Number,
			default: 0,
		},
		pageSize: {
			type: Number,
			default: 5,
		},
	},
	data() {
		return {
			naviPageIndex: 0,
		};
	},
	watch: {
		listIndex(val) {
			if (val < 0 || val > this.allGameList.length) return;
			this.naviPageIndex = val - (val % this.pageSize);
		},
		pageSize(val) {
			this.naviPageIndex = this.listIndex - (this.listIndex % val);
		},
	},
	methods: {
		moveTo(game, index) {
			dataLayer.push({
				event: 'GSBiconClick',
				linkId: `${game.title}${game.productId ? ` - ${game.productId}` : ''}`,
			});
			this.$emit('moveTo', index);
		},
		movePrev() {
			this.naviPageIndex = Math.max(this.naviPageIndex - 5, 0);
		},
		moveNext() {
			this.naviPageIndex = Math.min(this.naviPageIndex + 5, this.allGameList.length - 5);
		},
	},
};
</script>
